import { GetInvoicesRequest } from "@apis/requests/get-invoices-request";
import { ErrorResponseWrapper } from "@apis/errors/error-response-wrapper";
import config from "../environment/environment-config";

export const FETCH_INVOICES_BEGIN = "FETCH_INVOICES_BEGIN";
export const FETCH_INVOICES_SUCCESS = "FETCH_INVOICES_SUCCESS";
export const FETCH_MERGE_INVOICES_SUCCESS = "FETCH_MERGE_INVOICES_SUCCESS";
export const FETCH_INVOICES_FAILURE = "FETCH_INVOICES_FAILURE";

export const INVOICES_BASE_URL = config.apiUrls.invoicesApi;

export const fetchInvoicesBegin = (request) => ({
  type: FETCH_INVOICES_BEGIN,
  payload: request,
});

export const fetchInvoicesSuccess = (invoiceResponse, merge) => ({
  type: merge ? FETCH_MERGE_INVOICES_SUCCESS : FETCH_INVOICES_SUCCESS,
  payload: { invoiceResponse },
});

export const fetchInvoicesFailure = (errors) => ({
  type: FETCH_INVOICES_FAILURE,
  payload: { errors },
});

/**
 * @jsdoc method
 * @name getInvoices
 * @methodOf actions.invoiceActions
 * @description description
 * Get invoices
 */
export function getInvoices(
  request: GetInvoicesRequest,
  invoices,
  merge = false
) {
  const url = INVOICES_BASE_URL + request.toQueryString();
  return (dispatch) => {
    dispatch(fetchInvoicesBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        }
        return res.json();
      })
      .then((data) => {
        if (merge) {
          data.invoices = [...invoices, ...data.invoices];
        }
        dispatch(fetchInvoicesSuccess(data, merge));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchInvoicesFailure(messages));
        });
      });
  };
}
